import { BRAZILIAN_DDDS } from 'shared/presentation/constants';

const VALID_PHONE_DIGIT_COUNTS = [10, 11];
const MOBILE_SUBSCRIBER_NUMBER_LENGTH = 9;
const MOBILE_NUMBER_PREFIX = '9';

export default function isBrazilianCellphoneValid(phone: string) {
  const digits = phone.replace(/\D/g, '');

  if (!VALID_PHONE_DIGIT_COUNTS.includes(digits.length)) return false;

  const ddd = digits.slice(0, 2);
  const subscriberNumber = digits.slice(2);

  if (!BRAZILIAN_DDDS.includes(ddd)) return false;

  if (
    subscriberNumber.length === MOBILE_SUBSCRIBER_NUMBER_LENGTH &&
    !subscriberNumber.startsWith(MOBILE_NUMBER_PREFIX)
  ) {
    return false;
  }

  return true;
}
